// extracted by mini-css-extract-plugin
export default {"btn":"CustomButton_btn__dmJwB","fill":"CustomButton_fill__svlyT","outline":"CustomButton_outline__ppEKr"};